import { Link } from "react-router-dom";

export default function ContactInfoBar() {
  return (
    <div className="w-full bg-gradient-to-r from-blue-800 via-blue-900 to-blue-800 border-t border-blue-950">
      <div className="max-w-7xl mx-auto flex justify-center py-7 px-3">
        <Link
          to="/contact"
          className="
            flex items-center gap-2
            px-8 py-4
            rounded-2xl
            bg-white
            text-blue-900
            font-bold
            shadow-md hover:bg-blue-50
            text-xl
            transition-all duration-200
          "
        >
          <span role="img" aria-label="chat" className="text-2xl"></span>
          Request Consultation
        </Link>
      </div>
    </div>
  );
}
